import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount()    { document.addEventListener('keydown', this.handleKey); }
  componentWillUnmount() { document.removeEventListener('keydown', this.handleKey); }

  handleKey(e) {
    if (e.key === 'Escape' && this.props.open) {
      this.props.onClose && this.props.onClose();
    }
  }

  render() {
    const { open, onClose, title, subtitle, width = '600px', children, footer, closable = true, bodyPadding = true } = this.props;

    if (!open) return null;

    return ReactDOM.createPortal(
      <div className={styles.overlay} onClick={e => { if (e.target === e.currentTarget) onClose && onClose(); }}>
        <div className={styles.sheet} style={{ width }}>
          {(title || closable) && (
            <div className={styles.header}>
              <div className={styles.headerInfo}>
                {title    && <div className={styles.title}>{title}</div>}
                {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
              </div>
              {closable && (
                <button className={styles.closeBtn} onClick={onClose}>
                  <span className="material-symbols-rounded" style={{ fontSize: 18 }}>close</span>
                </button>
              )}
            </div>
          )}
          <div className={[styles.body, bodyPadding ? '' : styles.bodyFlush].join(' ')}>{children}</div>
          {footer && <div className={styles.footer}>{footer}</div>}
        </div>
      </div>,
      document.body
    );
  }
}

export default Modal;
